import { render, staticRenderFns } from "./MetadataForm.vue?vue&type=template&id=a971ffe2&scoped=true&"
import script from "./MetadataForm.vue?vue&type=script&lang=js&"
export * from "./MetadataForm.vue?vue&type=script&lang=js&"
import style0 from "../assets/css/forms.css?vue&type=style&index=0&id=a971ffe2&prod&scoped=true&lang=css&"
import style1 from "./MetadataForm.vue?vue&type=style&index=1&id=a971ffe2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a971ffe2",
  null
  
)

export default component.exports